import React, { useState } from 'react';
import {withRouter} from 'react-router-dom';
import styles from "./OrganisationInterStateDecision.module.scss";
import {Button, RadioSelector, ErrorMsg} from "@onegovbugs/onegov-react-components";
import {useSelector, useDispatch} from 'react-redux';
import {storeImportExportDetails, storeInterStateDetails, saveImportExportApplication} from "../../../redux/actions";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";  
import {isSelected, validate, scrollToError} from "../../../utils/Validation";

const OrganisationInterStateDecision = props => {


    ScrollToTop();
    RedirectIfCaptchaNotSelected(props);
    
    const importExportDetails = useSelector(state => state.importExportDetails);
    const interStateDetails = useSelector(state => state.interStateDetails);
    const dispatch = useDispatch();

    const [appType, setAppType] = useState(importExportDetails ? importExportDetails.interStateDecisionAppType : null);
    const [questionAppType, serQuestionAppType] = 
        useState(importExportDetails.ieType === "Export" 
            ? "Provide details of interstate person or business to whom the animals will be exported"
            : "Provide details of interstate person or business from whom the animals will be imported?");

    const applicationTypeValues = [
        {
            value: 'Individual',
            label: 'Individual'
        },
        {
            value: 'Organisation',
            label: 'Organisation'
        }
    ];

    const storeData = (finished) => {
        const importExportDetailsData = {
            ...importExportDetails,
            interStateDecisionAppType: appType,
            interStateDecisionAppTypeStep: 1,
            // interStateDecisionAppTypeFinished: finished
        };

        dispatch(storeImportExportDetails(importExportDetailsData));
    };       

    const continueButtonHandler = () => {

        if (validate(validators, setErrors)) {
            setShowErrors(false);
            storeData(true);
            dispatch(
                saveImportExportApplication("", () => {
                    props.history.push(`./interstate-organisation`);
                })
            );                           
        } else {
            setShowErrors(true);
            scrollToError();
        }    
        
    }

    const [showErrors, setShowErrors] = useState(false);

    const validators = [
        {
            fieldName: "interStateDecisionAppType",
            fieldValue: appType,
            isValid: (v) => (isSelected(v)),
        },
      ];

    const [errors, setErrors] = useState({
        interStateDecisionAppType: false,
    });     
    
    return (
        <div className={styles.mainCont}>
            <div className={"row"}>
                <div className={"col-12"}>

                    <label>{questionAppType}</label>
                    <div className={styles.topMargin24}>
                        <RadioSelector
                            options={applicationTypeValues}
                            onSelectionChange={(selectedValue) => {
                                setAppType(selectedValue);

                                if (selectedValue === 'Organisation' && interStateDetails.isIndividualValid)
                                {
                                    if(!interStateDetails.organisationIdType || interStateDetails.organisationIdType === '')
                                    {
                                        // var newInterStateDetails = {
                                        //     ...interStateDetails,
                                        //     step: 1,
                                        //     finished: false
                                        // }
                                        // dispatch(storeInterStateDetails(newInterStateDetails));

                                        const importExportDetailsData = {
                                            ...importExportDetails,
                                            interStateDecisionAppTypeStep: 2,
                                            interStateDecisionAppTypeFinished: false
                                          };
                                      
                                         dispatch(storeImportExportDetails(importExportDetailsData));    

                                    }
                                } 
                                //else {
                                //     if(interStateDetails.isIndividualValid)
                                //     {
                                //         var newInterStateDetails = {
                                //             ...interStateDetails,
                                //             finished: true
                                //         }
                                //         dispatch(storeInterStateDetails(newInterStateDetails)); 
                                //     }
                                // }                                
                                
                            }}
                            initialValue={appType}
                        />
                    </div>                    
                </div>
                {appType==null && errors.interStateDecisionAppType && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Please make a selection."}
                    />
                    </div>
                    ) : null}                    
            </div>

            <div className={`row ${styles.buttonCont}`}>
                <div className={`col-12`}>
                    <Button onClick={() => continueButtonHandler()}>
                        Continue
                    </Button>
                    <Button
                        secondary
                        onClick={() => {

                            storeData();
                            dispatch(
                                saveImportExportApplication("", () => {
                                    props.history.push(`./organisation-dashboard`);
                                })
                            );                         

                        }}>
                        Save & exit section
                    </Button>
                </div>
            </div>
        </div>

    );    


    

};

export default withRouter(props => <OrganisationInterStateDecision {...props}/>);
